// extracted by mini-css-extract-plugin
export default {"name":"deviceRow__name-tTUsN","apps":"deviceRow__apps-WwrwR","menuItem":"deviceRow__menuItem-sv2Xc","menu":"deviceRow__menu-Z_ghv"};